/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Calendar_GoogleInputs */



/**
* | output |
* | --- |
* | "Google Workspace" |
*
* @param {Onboarding_Calendar_GoogleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_calendar_google = /** @type {((inputs?: Onboarding_Calendar_GoogleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Calendar_GoogleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Google Workspace")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Google Workspace")
	return /** @type {LocalizedString} */ ("Google Workspace")
});